import { RECEIVE_ALTERNATE_EMAILS, REQUEST_ALTERNATE_EMAILS } from '@Actions/alternate_email';
const defaultState = {
    alternateEmails: null,
    loading: false
};
export function alternateEmails(state = defaultState, action) {
    switch (action.type) {
        case REQUEST_ALTERNATE_EMAILS:
            return { loading: true, alternateEmails: null };
        case RECEIVE_ALTERNATE_EMAILS:
            return {
                loading: false,
                alternateEmails: action.emails
            };
        default:
            return state;
    }
}
